<!-- We're moving this to pure front-end because there's a lot of JS behavior that we need to encapsulate -->
<!-- Algorithm form on the admin side will need to have an equivalent -->

<template>
  <div ref="container">
    <div class="w-full grow criteria flex flex-col space-y-3">
      <!-- Headings -->
      <div class="flex space-x-4 items-center">
        <div class="flex space-x-4 items-center grow">
          <div class="flex space-x-4 grow">
            <div class="w-1/2">Searcher Criteria</div>
            <div class="w-1/2">Responder Criteria</div>
          </div>
          <div class="w-48">Importance</div>
          <div class="w-16">Mapped</div>
          <div class="w-16">Fuzzy</div>
        </div>
        <div class="w-10"></div> <!-- for the delete button -->
      </div>

      <div v-for="(usc, index) in algorithmSearchCriteria"  :key="usc.id" v-show="!usc.hidden" class="nested-form-item">
        <div class="group flex space-x-4 items-start">
          <AlgorithmCriterionFields
            v-bind="generateFieldNames(index)"
            :initial-values="usc.values"
            :criteria="criteria"
            :importances="importances"
            :searchableGroups="searchableGroups"
            :searchableTags="searchableTags"
            :programId="programId">
          </AlgorithmCriterionFields>

          <button type="button" @click="removeEntry(index)" class="button w-10 secondary flex justify-center items-center" :disabled="visibleSearchCriteria.length<2">
            <i class="fa fa-times h-5 before:h-5 before:leading-5"><span class="sr-only">{{ removeString }}</span></i>
          </button>
        </div>
      </div>
    </div>

    <div class="flex space-x-3 justify-end mt-6">
      <button type="button" @click="addEntry" class="secondary button">
        <i class="fa far fa-plus"></i><span>{{ addString }}</span>
      </button>

      <!-- TODO: pass in the localized text -->
      <input type="submit" id="search-button" class="button w-fit" :value="submitString">
    </div>

    <input type="hidden" name="sort_by" :value="sortBy" v-if="sortBy" />
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import AlgorithmCriterionFields from './AlgorithmCriterionFields.vue'

  const props = defineProps({
    parentModel:              { type: String, default: 'algorithm' },
    initialSearchCriteria:    { type: Array, default: () => [] },
    sortBy:                   { type: String, default: null },
    submitString:             { type: String, default: 'Search' },
    addString:                { type: String, default: 'Add Field' },
    removeString:             { type: String, default: 'Delete criterion' },
    criteria:                 { type: Array, default: () => [] }, // constant arrays
    importances:              { type: Array, default: () => [] },
    searchableTags:           { type: Array, default: () => [] },
    searchableGroups:         { type: Array, default: () => [] },
    programId:                { type: Number, default: -999 }
  })

  const algorithmSearchCriteria = ref(props.initialSearchCriteria)
  const criteria = props.criteria
  const importances = props.importances
  const searchableGroups = props.searchableGroups
  const searchableTags = props.searchableTags
  const searchableAvailabilities = props.searchableAvailabilities
  const programId = props.programId
  const nextIndex = ref(props.initialSearchCriteria.length)
  const container = ref(null)
  const generateFieldNames = (index) => ({
    myFieldIdFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][my_field_id]`,
    myCriterionTextFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][my_criterion_text]`,
    myCriterionValueIdsFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][my_criterion_value_ids]`,
    myListValueIdsFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][my_list_value_ids]`,
    otherFieldIdFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][other_field_id]`,
    otherCriterionTextFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][other_criterion_text]`,
    otherCriterionValueIdsFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][other_criterion_value_ids]`,
    otherListValueIdsFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][other_list_value_ids]`,
    importanceFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][importance]`,
    fuzzyFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][fuzzy]`,
    mappedFieldName: `${props.parentModel}[algorithm_search_criteria_attributes][${index}][mapped]`
  })
  const submitString = props.submitString
  const addString = props.addString

  const addEntry = () => {
    const index = nextIndex.value
    const {
      myFieldIdFieldName,
      myCriterionTextFieldName,
      myCriterionValueIdsFieldName,
      myListValueIdsFieldName,
      otherFieldIdFieldName,
      otherCriterionTextFieldName,
      otherCriterionValueIdsFieldName,
      otherListValueIdsFieldName,
      importanceFieldName,
      fuzzyFieldName,
      mappedFieldName,
    } = generateFieldNames(index)

    // Defaults will be handled in SearchCriterionFields.vue
    algorithmSearchCriteria.value.push({ id: index})

    nextIndex.value++
  }

  const visibleSearchCriteria = computed(() => {
    return algorithmSearchCriteria.value.filter((usc) => usc.hidden !== true)
  })

  const removeEntry = (index) => {
    if (algorithmSearchCriteria.value[index].persisted) {
      const destroyField = document.createElement('input')
      destroyField.type = 'hidden'
      destroyField.name = `${props.parentModel}[algorithm_search_criteria_attributes][${index}][_destroy]`
      destroyField.value = '1'
      container.value?.appendChild(destroyField)
      algorithmSearchCriteria.value[index].hidden = true
    } else {
      algorithmSearchCriteria.value.splice(index, 1)
    }
  }
</script>
